(ns dre.modals.admin.feed.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.modals.events :as-alias modals]
   [dre.network :as-alias network]
   [dre.pages.admin.feed.events :as-alias admin-feed]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path
  [:modals :admin :feed])

; vvv EVENTS vvv

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [opts]]
  {:db (merge db opts)}))

(rf/reg-event-db
 ::on-change
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [db [k v]]
  (assoc-in db k v)))

(rf/reg-event-fx
 ::submit-edit-form
 [(rf/path db-path)]
 (fn-traced
  [{db :db} _]
  (let [{:keys [source-id title category]} (:edit db)]
    {; :db ; TODO show loader
     ::network/request [{:endpoint :admin/feeds.update
                         :context {:id source-id}}
                        {:body {:title title
                                :category category}
                         :request-content-type :json
                         :response-content-type :json
                         :on-success [::submit-edit-form-ok]
                         :on-failure [::submit-edit-form-nok]}]})))

(rf/reg-event-db
 ::submit-edit-form-ok
 [(rf/path db-path)]
 (fn-traced
  [db _]
  #_TODO_remove-loader
  db))

(rf/reg-event-db
 ::submit-edit-form-nok
 [(rf/path db-path)]
 (fn-traced
  [db _]
  #_TODO_show-error
  db))

(rf/reg-event-fx
 ::delete-feed
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} _]
  (let [id (get-in db [:delete :source-id])]
    {:db (assoc db :delete-in-progress? true)
     ::network/request [{:endpoint :admin/feeds.delete
                         :context {:id id}}
                        {:request-content-type :json
                         :response-content-type :json
                         :on-success [::delete-feed-ok {:id id}]}]})))

(rf/reg-event-fx
 ::delete-feed-ok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{:keys [db]} [{:keys [:id]}]]
  {:db (assoc db :delete-in-progress? false)
   :fx [[:dispatch [::admin-feed/delete-feed id]]
        [:dispatch [::modals/clear]]]}))

(rf/reg-event-fx
 ::add-new-feed
 [(rf/path db-path)]
 (fn-traced
  [{db :db} _]
  (let [{:keys [title link category feed-id]} (:add db)]
    {:db (assoc db :add-in-progress? true)
     ::network/request [{:endpoint :admin/feeds.add}
                        {:body {:link link
                                :title title
                                :category category
                                :feed-id feed-id}
                         :request-content-type :json
                         :response-content-type :json
                         :on-success [::add-new-feed-ok]
                         :on-failure [::add-new-feed-nok]}]})))

(rf/reg-event-fx
 ::add-new-feed-ok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{:keys [db]} [{::fetch-fx/keys [response]}]]
  {:db (assoc db :add-in-progress? false)
   :fx [[:dispatch [::admin-feed/add-new-feed (:body response)]]
        [:dispatch [::modals/clear]]]}))

(rf/reg-event-fx
 ::add-new-feed-nok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{:keys [db]} [opts]]
  {:db (assoc db :add-in-progress? false)
   :dispatch [::network/default-failure opts]}))

; vvv SUBS vvv

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db db-path)))

(rf/reg-sub
 ::value-of
 :<- [::state]
 (fn [state [_ k]]
   (get-in state k)))

(rf/reg-sub
 ::delete-in-progress?
 :<- [::state]
 (fn [state _]
   (:delete-in-progress? state)))

(rf/reg-sub
 ::add-in-progress?
 :<- [::state]
 (fn [state _]
   (:add-in-progress? state)))
